import { render } from "./App.vue?vue&type=template&id=55bd1433"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=55bd1433&lang=scss"

import exportComponent from "C:\\__MRYNK\\_2022\\_TESTS\\poc-microphone\\poc-record\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__